import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment, environmentComerciantes,environmentEmpleados } from '@environments/environment';

import { environmentProductos } from '@environments/environment';

import { User, Proveedor } from '@app/_models';

import { UserService } from './user.service';

import { Router, UrlSegment } from '@angular/router';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    //CURRENT USER PRODUCTOS

    private currentUserSubject: BehaviorSubject<User>;

    public currentUser: Observable<User>;

    

    //CURRENT USER COMERCIANTES

    public currentUserComerciantes: Observable<User>;

    private currentUserSubjectComerciantes: BehaviorSubject<User>;

    //CURRENT USER EMPLEADOS

    public currentUserEmpleados: Observable<User>;

    public currentUserSubjectEmpleados:BehaviorSubject<User>

    public show = true;

    constructor(

        private http: HttpClient,

        private userService: UserService,

        private router: Router,

        ) {

        //CURRENT VALUE PRODUCTOS

        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));

        this.currentUser = this.currentUserSubject.asObservable();

        //CURRENT VALUE COMERCIANTES

        this.currentUserSubjectComerciantes = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUserComerciantes')));

        this.currentUserComerciantes = this.currentUserSubjectComerciantes.asObservable();

        //CURRENT VALUE EMPLEADOS

        this.currentUserSubjectEmpleados = new BehaviorSubject<any>(JSON.parse(sessionStorage.getItem('currentUserEmpleados')));

        this.currentUserEmpleados = this.currentUserSubjectEmpleados.asObservable();

    }

    public get currentUserValue(): User {

        return this.currentUserSubject.value;

    }

    public get currentUserValueComerciantes(): User {

        return this.currentUserSubjectComerciantes.value;

    }

    public get currentUserValueEmpleados(): User {

        return this.currentUserSubjectEmpleados.value;

    }

    public isShow(){

        return this.show;

    }

    ngOnInit(){}

   

    async loginParticipantes(WicID: string, Password: string) {

        const secret_key = environment.secretKey;

        const response = await this.http.post<any>(`${environment.apiUrl}/Auth/Login`, { WicID, Password, secret_key }).toPromise();

        

        if (response.objeto) {

            const userId = response.objeto.userId;

            const token = response.objeto.accessToken;

            const roleID = '0';

            try {

                const response = await this.userService.getIdParticipantes(userId).toPromise();

                const user: User = response['objeto'];

                user.token = token;

                user.roleID = roleID;

                // store user details and jwt token in local storage to keep user logged in between page refreshes

                localStorage.setItem('currentUser', JSON.stringify(user));

                this.currentUserSubject.next(user);

                return user;

            } catch (error) {

                 throw error;

            }

        } else {

            const error = 'Usuario y/o contrase�a inv�lidos';

            throw error;

        }

    }



    async loginProductos(user: string, Password: string) {

        //Clave privada de api.

        const secret_key = environmentProductos.secretKey;

        //Definici�n de usuario para hacer el login.

        let usuario = {

            UserName : user,

            Password: Password,

            secret_key : secret_key

        }

        //console.log("user en login",usuario);

        //Peticion a la api para login.

        console.log("le pega a ", `${environmentProductos.apiUrl}/Auth/Login`)

        const response = await this.http.post<any>(`${environmentProductos.apiUrl}/Auth/Login`, usuario).toPromise();

        console.log(response)

        //Control de estado de request.

        if (response.objeto) {

            //Guardado de Usuario ID

            const userId = response.objeto.userId;

            //set variable global

            this.show = true;

            // Guardado de token de authentication

            const token = response.objeto.accessToken;

            //Guardado de rol de usuario

            const roleID = response.objeto.user.role.roleID;

            try {

                // Peticion que trae la informacion del usuario logeado.

                

                /*

                //IF TIPO DE USUARIO ES EL TIPO DE GET QUE SE HACE

                const response = await this.userService.getIdDistribuidor(userId).toPromise();

                */

                // Pedido de memoria a objeto user e inicializacion con respuesta de api.

                const user: User = response['objeto'];

                //Guardado de token

                user.token = token;

                //Guardado de rol 

                user.roleID = roleID;

                // store user details and jwt token in local storage to keep user logged in between page refreshes

                localStorage.setItem('currentUser', JSON.stringify(user));

                //next a objeto observable y guardado de session

                this.currentUserSubject.next(user);

                return user;

            }catch (error) {

                console.log("ERROR",error)

                 throw error;

            }

        }else {

            const error = response;

            throw error;

        }

    }

    async loginComerciante(user: string, Password: string) {

        //Definici�n de usuario para hacer el login.

        let usuario = {

            UserName : user,

            Password: Password,

            RoleID: 2

        }

        //Peticion a la api para login.

        const response = await this.http.post<any>(`${environmentComerciantes.apiUrl}/Auth/Login`, usuario).toPromise();

        console.log("login comerciantes",response)

        //Control de estado de request.

        if (response.objeto) {

            //set variable global

            this.show = true;

            // Guardado de token de authentication

            const token = response.objeto.accessToken;

           // console.log("el token", token)

            // Desencrypto token 

            const user =  JSON.parse(atob(token.split('.')[1]));

            console.log("user1",user)

            user.IsReadyToContract == "False" ?  user.IsReadyToContract = false:  user.IsReadyToContract= true;

            try {

                // Pedido de memoria a objeto user e inicializacion con respuesta de api.

                let comerciante: User = new User(user);

                //Guardado de ID

                comerciante.userID = user.UserID;

                //Guardado de Nombre

                comerciante.firstName = user.Username;

                comerciante.secondName= user.firstName??"" + " " + user.Surname??"";

                comerciante.firstLastName=user.FatherLastname;

                comerciante.secondLastName=user.MotherLastname;

                comerciante.Correo = user.Correo;



                //Guardado de token

                comerciante.token = token;

                //Guardado de corporacion

                comerciante.corporation = user.Corporation;

                comerciante.IsReadyToContract = user.IsReadyToContract;

                comerciante.Sellos = user.Sellos;

                // store user details and jwt token in local storage to keep user logged in between page refreshes

                sessionStorage.setItem('currentUserComerciantes', JSON.stringify(comerciante));

                //next a objeto observable y guardado de session

                this.currentUserSubjectComerciantes.next(comerciante);

                return comerciante;

            }catch (error) {

                console.log("ERROR",error)

                 throw error;

            }

        }else {

            const error = response;

            throw error;

        }

    }

    loginEmpleados() {

        //Peticion a la api para login.

        if(!this.isAuthEmpleados()){

            

            this.http.get<any>(`${environmentEmpleados.apiUrl}/Auth/Login`).subscribe((response)=>{

                //Control de estado de request.

                console.log("RESPONSE",response)

                if (response.Objeto) {

                    //set variable global

                    this.show = true;

                    // Guardado de token de authentication

                    const token = response.Objeto.AccessToken;

                    // console.log("el token", token)

                    // Desencrypto token 

                    const user =  JSON.parse(atob(token.split('.')[1]));

                    user.IsReadyToContract == "False" ?  user.IsReadyToContract = false:  user.IsReadyToContract= true;

                    try {

                        // Pedido de memoria a objeto user e inicializacion con respuesta de api.

                        let empleado: User = new User(user);

                        //Guardado de ID

                        empleado.userID = user.UserId;

                        //Guardado de Nombre

                        empleado.firstName = user.Username;

                        //Guardado de token

                        empleado.token = token;

                        //Guardado de corporacion

                        empleado.corporation = user.Corporation;

                        empleado.IsReadyToContract = user.IsReadyToContract;

                        // store user details and jwt token in local storage to keep user logged in between page refreshes

                        sessionStorage.setItem('currentUserEmpleados', JSON.stringify(empleado));

                        //next a objeto observable y guardado de session

                        this.currentUserSubjectEmpleados.next(empleado);

                        console.log("NEXT",empleado,sessionStorage.getItem("currentUserEmpleados"))

                        return empleado;

                    }catch (error) {

                        console.log("ERROR",error)

                            throw error;

                    }

                }else {

                    const error = 'Error';

                    throw error;

                }

            })

            

        }

        

    }

    isAuthEmpleados(){

        if(this.currentUserValueEmpleados)

         return true;

         else

         return false   

    }

    recuperarPasswordComerciantes(user:any){

        return this.http.post<User>(`${environmentComerciantes.apiUrl}/Auth/ChangePassword`, user);

    }

  

    SolicitarNuevaPasswordComerciantes(user:any){

        return this.http.post<User>(`${environmentComerciantes.apiUrl}/Auth/RecoverPassword`, user);

    }

    logout() {

        localStorage.removeItem('currentUser');

        this.show = false;

        this.currentUserSubject.next(null);

        this.router.navigate(['/home']);

    }

    logoutComerciantes() {

        sessionStorage.removeItem('currentUserComerciantes');

        this.show = false;

        this.currentUserSubjectComerciantes.next(null);

    }

    logoutEmpleados(){

        sessionStorage.removeItem('currentUserEmpleados');

        this.show = false;

        this.currentUserSubjectEmpleados.next(null);

    }

    getCurrent(){

        return this.currentUserSubject.value;

    }

    getCurrentComerciantes(){

        return this.currentUserSubjectComerciantes.value;

    }

    getCurrentEmpleado(){

        return this.currentUserSubjectEmpleados.value;

    }

    actualizarUser(user){

        let aux = this.currentUserValue;

        aux.user = user;

        // store user details and jwt token in local storage to keep user logged in between page refreshes

        localStorage.setItem('currentUser', JSON.stringify(aux));

        //next a objeto observable y guardado de session

        this.currentUserSubject.next(aux);

        return user;

    }

    actualizarEmpleado(user){

        // store user details and jwt token in local storage to keep user logged in between page refreshes

        sessionStorage.setItem('currentUserEmpleados', JSON.stringify(user));

        //next a objeto observable y guardado de session

        this.currentUserSubject.next(user);

        console.log("actualizar empleado", JSON.parse(sessionStorage.getItem('currentUserEmpleados')))

        return user;

    }



    

    actualizarUserComerciantes(user){

        let aux = this.currentUserValueComerciantes;

        aux.user = user;

        // store user details and jwt token in local storage to keep user logged in between page refreshes

        sessionStorage.setItem('currentUserComerciantes', JSON.stringify(aux));

        //next a objeto observable y guardado de session

        this.currentUserSubjectComerciantes.next(aux);

        return user;

    }

    validateUser(value:any){

        

        console.log("value",value)

        let json = {

            firstName: value.firstName,

            surname: value.surname,

            FatherLastName: value.FatherLastName,

            MotherLastName: value.MotherLastName,

            username:  value.username

        }

        console.log("json", json)

        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Auth/ValidateUser`, json);

    }

    cambiarPasswordByUserID(value:any){

    

        let json = {

            UserID: value.userID,

            Password: value.Password

        }

        console.log("json", json)

        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Auth/ChangePasswordById`, json);

    }

}

